<template>
	<div class="newListDiv">
		<div class="titleBox flexDiv">
			<p>
				<em>公告信息</em>
				<span>PROFESSIONAL TITLE EVALUATION</span>
			</p>
			<!-- <a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s"></a> -->
      <router-link :to="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s"><i></i></router-link>
		</div>
		<ul class="wutuUL">
			<li v-for="(item,index) in ggxxList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
        <router-link  :to="item.Url" :href="item.Url" class="flexDiv">
          <p><em>{{item.ShowTime2}}</em><i>{{setTimeformat(item.ShowTime6,'mm-YYYY')}}</i></p>
          <span>{{item.Title}}</span>
        </router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'ggxx',
		props:{
			ggxxList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/ggxx.vue